import { theme } from './theme'
import { Components, Theme } from '@mui/material/styles'

const layoutToolbarHeight = '6rem'

export const toolbarTheme: Components<Theme>['MuiToolbar'] = {
  styleOverrides: {
    root: {
      minHeight: layoutToolbarHeight,
      [theme.breakpoints.up('sm')]: {
        minHeight: layoutToolbarHeight,
      },
    },
  },
}
